import {configureStore} from "@reduxjs/toolkit"
import env from "../config/env"
import State from "../models/state"
import textAlignmentReducer from "./text-alignment"
import productSummaryReducer from "./productSummary"
import lazyloadReducer from "./lazyload"
import requestReducer from "./request"
import textReducer from "./text"
import templateSettingsReducer from "./template"

const {DEVELOPMENT} = env

const rootReducer = {
    productSummary: productSummaryReducer,
    textAlignment: textAlignmentReducer,
    lazyload: lazyloadReducer,
    request: requestReducer,
    text: textReducer,
    template: templateSettingsReducer,
}

type Reducers = typeof rootReducer
type ActionTypes = {
    [K in keyof Reducers]: Parameters<Reducers[K]>[1]
}

export const makeStore = (initialState?: State) => {
    return configureStore<State, ActionTypes[keyof ActionTypes]>({
        reducer: rootReducer as any,
        devTools: DEVELOPMENT,
        preloadedState: initialState,
    })
}
